<template>
  <!-- <v-container class="taux-revente-container"> -->
    <!-- État de chargement -->
      
      
    <v-row v-if="loading" justify="center" align="center"  class="mt-4">
      Saisons : <v-chip size="small" v-for="value in saisons" :style="[saison==value.saison?{'color':'green'}:'']" @click="saison=value.saison;fetchData()">{{ value.saison }}</v-chip>
      <v-col cols="12" class="text-center">
        <v-progress-circular
          indeterminate
          color="primary"
          size="64"
        ></v-progress-circular>
        <p class="mt-4 text-body-1">Chargement des données...</p>
      </v-col>
    </v-row>

    <!-- État d'erreur -->
    <v-row v-else-if="error" justify="center"  class="mt-4">
      Saisons : <v-chip size="small" v-for="value in saisons" :style="[saison==value.saison?{'color':'green'}:'']" @click="saison=value.saison;fetchData()">{{ value.saison }}</v-chip>
      <v-col cols="12" md="8">
        <v-alert
          type="error"
          variant="tonal"
          prominent
          :text="error"
          title="Erreur"
        ></v-alert>
      </v-col>
    </v-row>

    <!-- Aucune donnée -->
    <v-row  v-else-if="!data || data.length === 0"  class="mt-4">
      <v-col cols="12" md="12">
        Saisons : <v-chip size="small" v-for="value in saisons" :style="[saison==value.saison?{'color':'green'}:'']" @click="saison=value.saison;fetchData()">{{ value.saison }}</v-chip>
      
        <v-alert
          type="info"
          variant="tonal"
          text="Aucune donnée disponible"
          title="Information"
        ></v-alert>
      </v-col>
    </v-row>

    <!-- Affichage des données -->
    <template v-else>
      <!-- Informations supplémentaires -->
       
      <v-row class="mt-4">
        
        <v-col cols="12">
          Saisons : <v-chip size="small" v-for="value in saisons" :style="[saison==value.saison?{'color':'green'}:'']" @click="saison=value.saison;fetchData()">{{ value.saison }}</v-chip>
          <v-card  variant="outlined" class="pa-4">
            
            <!-- <v-chip size="small" :style="[saison=='H26'?{'color':'green'}:'']" @click="saison='H26';fetchData()">H26</v-chip> -->
            <v-row>
              <v-col cols="12" md="4">
                <div class="text-caption text-medium-emphasis">Ventes totales</div>
                <div class="text-h6">{{ stats.totalVentes }}</div>
                <div class="text-caption text-grey">
                  {{ getSalesLabels() }}
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div class="text-caption text-medium-emphasis">Approvisionnement total</div>
                <div class="text-h6">{{ stats.totalReceptions }}</div>
                
                <div class="d-flex flex-wrap ga-1 mt-1">
                  <v-chip
                    v-for="(value, key) in etabSupply"
                    :key="key"
                    size="x-small"
                    variant="outlined"
                    class="ma-1"
                  >
                    {{ `${key} : ${value}` }}
                  </v-chip>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div class="text-caption text-medium-emphasis">Taux de revente</div>
                <v-chip 
                  :color="getTauxColor()"
                  size="large"
                >
                  {{ (stats.tauxRevente ).toFixed(2) }}%
                </v-chip>
                <div class="text-caption text-grey mt-1">
                  {{ getRateInterpretation() }}
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <!-- Tableau des données regroupées par code article -->
      <v-row class="mt-6" v-if="false">
        <v-col cols="12">
          <v-card elevation="2">
            <v-card-item>
              <v-card-title class="text-h6 font-weight-medium">
                <v-icon icon="mdi-table" class="mr-2"></v-icon>
                Détail par article
              </v-card-title>
              <v-card-subtitle v-if="isRegrouped">
                Cliquez sur un groupe pour développer/réduire les détails par code barre
              </v-card-subtitle>
            </v-card-item>
            <v-divider></v-divider>
            <v-card-text>
              <!-- Affichage avec regroupement -->
              <v-data-table
                v-if="isRegrouped"
                :headers="tableHeaders"
                :items="tableData"
                :group-by="['code_article']"
                :items-per-page="-1"
                item-value="code_article"
                hide-default-footer
                hover
                return-object
              >
                <!-- En-tête du groupe -->
                <template v-slot:group-header="{ item, columns, toggleGroup, isGroupOpen }">
                  <tr>
                    <td
                      :colspan="columns.length"
                      class="cursor-pointer group-header"
                      v-ripple
                      @click="toggleGroup(item)"
                    >
                      <div class="d-flex align-center justify-space-between">
                        <div class="d-flex align-center">
                          <v-btn
                            :icon="isGroupOpen(item) ? '$expand' : '$next'"
                            color="primary"
                            density="comfortable"
                            size="small"
                            variant="tonal"
                            class="mr-3"
                          ></v-btn>
                          
                          <v-chip color="primary" variant="flat" class="mr-3">
                            {{ item.value }}
                          </v-chip>
                          
                          <span class="text-subtitle-1 font-weight-medium">
                            {{ getGroupSummary(item.items) }}
                          </span>
                        </div>
                        
                        <div class="d-flex align-center ga-2 flex-wrap">
                          <v-chip 
                            size="small" 
                            color="primary" 
                            variant="tonal"
                          >
                            <v-icon icon="mdi-cart" size="small" class="mr-1"></v-icon>
                            Ventes: {{ getGroupTotalVentes(item.items) }}
                          </v-chip>
                          <v-chip 
                            size="small" 
                            color="success" 
                            variant="tonal"
                          >
                            <v-icon icon="mdi-package-variant" size="small" class="mr-1"></v-icon>
                            Réceptions: {{ getGroupTotalReceptions(item.items) }}
                          </v-chip>
                          <v-chip 
                            size="small" 
                            :color="getGroupTauxColor(item.items)"
                            variant="tonal"
                          >
                            <v-icon icon="mdi-percent" size="small" class="mr-1"></v-icon>
                            Taux: {{ getGroupTaux(item.items) }}%
                          </v-chip>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>

                <!-- Ligne de détail par code barre -->
                <template v-slot:item="{ item }">
                  <tr>
                    <td>
                      <div class="d-flex align-center">
                        <v-icon icon="mdi-barcode" size="small" color="grey" class="mr-2"></v-icon>
                        <span>{{ item.codeabarre }}</span>
                      </div>
                    </td>
                    <td>
                      <v-chip size="x-small" color="grey" variant="outlined">
                        {{ item.couleur || '-' }}
                      </v-chip>
                    </td>
                    <td>
                      <v-chip size="x-small" color="grey" variant="outlined">
                        {{ item.taille || '-' }}
                      </v-chip>
                    </td>
                    <td class="text-center">
                      <v-chip size="small" color="primary" variant="tonal">
                        {{ parseInt(item.quantitevte || 0) + parseInt(item.quantiteneg || 0) }}
                      </v-chip>
                    </td>
                    <td class="text-center">
                      <v-chip size="small" color="success" variant="tonal">
                        {{ parseInt(item.quantitebrf || 0) }}
                      </v-chip>
                    </td>
                    <td class="text-center">
                      <v-chip 
                        size="small" 
                        :color="getItemTauxColor(item)"
                        variant="tonal"
                      >
                        {{ getItemTaux(item) }}%
                      </v-chip>
                    </td>
                    <td class="text-center">
                      <v-btn
                        icon
                        size="x-small"
                        variant="text"
                        color="primary"
                        @click="showDetails(item)"
                      >
                        <v-icon icon="mdi-eye" size="small"></v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>

                <!-- Message pour groupe vide -->
                <template v-slot:group-no-items>
                  <tr>
                    <td colspan="7" class="text-center pa-4">
                      <span class="text-caption text-medium-emphasis">Aucun détail disponible</span>
                    </td>
                  </tr>
                </template>
              </v-data-table>

              <!-- Affichage simplifié si pas de regroupement -->
              <v-table v-else density="comfortable">
                <thead>
                  <tr>
                    <th class="text-uppercase text-caption font-weight-bold">Code Barre</th>
                    <th class="text-uppercase text-caption font-weight-bold">Couleur</th>
                    <th class="text-uppercase text-caption font-weight-bold">Taille</th>
                    <th class="text-uppercase text-caption font-weight-bold text-center">Ventes</th>
                    <th class="text-uppercase text-caption font-weight-bold text-center">Réceptions</th>
                    <th class="text-uppercase text-caption font-weight-bold text-center">Taux Revente</th>
                    <th class="text-uppercase text-caption font-weight-bold text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in tableData" :key="item.codeabarre">
                    <td>{{ item.codeabarre }}</td>
                    <td>{{ item.couleur || '-' }}</td>
                    <td>{{ item.taille || '-' }}</td>
                    <td class="text-center">
                      <v-chip size="small" color="primary" variant="tonal">
                        {{ parseInt(item.quantitevte || 0) + parseInt(item.quantiteneg || 0) }}
                      </v-chip>
                    </td>
                    <td class="text-center">
                      <v-chip size="small" color="success" variant="tonal">
                        {{ parseInt(item.quantitebrf || 0) }}
                      </v-chip>
                    </td>
                    <td class="text-center">
                      <v-chip 
                        size="small" 
                        :color="getItemTauxColor(item)"
                        variant="tonal"
                      >
                        {{ getItemTaux(item) }}%
                      </v-chip>
                    </td>
                    <td class="text-center">
                      <v-btn
                        icon
                        size="small"
                        variant="text"
                        color="primary"
                        @click="showDetails(item)"
                      >
                        <v-icon icon="mdi-eye" size="small"></v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Détails de l'article dans un dialogue -->
      <v-dialog v-model="dialogVisible" max-width="600px">
        <v-card>
          <v-card-title class="text-h5 font-weight-medium">
            <v-icon icon="mdi-information" class="mr-2"></v-icon>
            Détails de l'article
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-4">
            <v-list>
              <v-list-item>
                <v-list-item-title class="text-caption text-medium-emphasis">
                  Code Article
                </v-list-item-title>
                <v-list-item-subtitle class="text-body-1 font-weight-medium">
                  {{ selectedItem?.code_article }}
                </v-list-item-subtitle>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-title class="text-caption text-medium-emphasis">
                  Code Barre
                </v-list-item-title>
                <v-list-item-subtitle class="text-body-1 font-weight-medium">
                  {{ selectedItem?.codeabarre }}
                </v-list-item-subtitle>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-title class="text-caption text-medium-emphasis">
                  Marque
                </v-list-item-title>
                <v-list-item-subtitle class="text-body-1 font-weight-medium">
                  {{ selectedItem?.marque }}
                </v-list-item-subtitle>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-title class="text-caption text-medium-emphasis">
                  Saison
                </v-list-item-title>
                <v-list-item-subtitle class="text-body-1 font-weight-medium">
                  {{ selectedItem?.saison }}
                </v-list-item-subtitle>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-title class="text-caption text-medium-emphasis">
                  Couleur / Taille
                </v-list-item-title>
                <v-list-item-subtitle class="text-body-1 font-weight-medium">
                  {{ selectedItem?.couleur || '-' }} / {{ selectedItem?.taille || '-' }}
                </v-list-item-subtitle>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-title class="text-caption text-medium-emphasis">
                  Quantités
                </v-list-item-title>
                <v-list-item-subtitle class="text-body-1">
                  <v-chip size="small" color="primary" variant="tonal" class="mr-2">
                    Ventes: {{ parseInt(selectedItem?.quantitevte || 0) }}
                  </v-chip>
                  <v-chip size="small" color="error" variant="tonal" class="mr-2">
                    Négatif: {{ parseInt(selectedItem?.quantiteneg || 0) }}
                  </v-chip>
                  <v-chip size="small" color="success" variant="tonal">
                    Reçu: {{ parseInt(selectedItem?.quantitebrf || 0) }}
                  </v-chip>
                </v-list-item-subtitle>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-title class="text-caption text-medium-emphasis">
                  Taux de revente
                </v-list-item-title>
                <v-list-item-subtitle class="text-body-1">
                  <v-chip 
                    :color="getItemTauxColor(selectedItem)"
                    size="large"
                  >
                    {{ getItemTaux(selectedItem) }}%
                  </v-chip>
                </v-list-item-subtitle>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              variant="tonal"
              @click="dialogVisible = false"
            >
              Fermer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  <!-- </v-container> -->
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import axios from 'axios';

// Props
const props = defineProps({
  p_saison: {
    type: String,
    required: true
  },
  p_code_article: {
    type: String,
    required: true
  },
  p_codeabarre: {
    type: String
    // ,
    // required: true
  },
  quantityLabels: {
    type: Object,
    default: () => ({
      frontOfficeSalesQuantity: { libelle: 'Ventes front office' },
      customerDeliveryQuantity: { libelle: 'Livraisons client' },
      customerInvoiceQuantity: { libelle: 'Facturations client' }
    })
  }
});

// États
let saison=ref(props.p_saison)
const data = ref(null);
const loading = ref(true);
const error = ref(null);
const stats = ref({
  totalVentes: 0,
  totalReceptions: 0,
  tauxRevente: 0
});
const isRegrouped = ref(false);
const dialogVisible = ref(false);
const selectedItem = ref(null);
const etabSupply = ref({});
const groupedData = ref([]);

// En-têtes du tableau
const tableHeaders = [
  { 
    title: 'Code Barre', 
    key: 'codeabarre',
    sortable: true,
    width: '15%'
  },
  { 
    title: 'Couleur', 
    key: 'couleur',
    sortable: true,
    width: '10%'
  },
  { 
    title: 'Taille', 
    key: 'taille',
    sortable: true,
    width: '10%'
  },
  { 
    title: 'Ventes', 
    key: 'quantitevte',
    sortable: true,
    width: '15%',
    align: 'center'
  },
  { 
    title: 'Réceptions', 
    key: 'quantitebrf',
    sortable: true,
    width: '15%',
    align: 'center'
  },
  { 
    title: 'Taux Revente', 
    key: 'taux',
    sortable: true,
    width: '20%',
    align: 'center'
  },
  { 
    title: 'Action', 
    key: 'actions',
    sortable: false,
    width: '15%',
    align: 'center'
  }
];

// Données du tableau
const tableData = computed(() => {
  if (!data.value) return [];
  
  if (isRegrouped.value) {
    // Pour le regroupement, on retourne les données avec la structure correcte
    return data.value;
  }
  
  // Si pas de regroupement, on retourne les données simples
  return data.value.map(item => ({
    ...item,
    taux: getItemTaux(item)
  }));
});
// console.log(tableData);

// Fonctions pour le groupe
const getGroupSummary = (items) => {
  if (!items || items.length === 0) return '';
  return `${items.length} déclinaison(s)`;
};

const getGroupTotalVentes = (items) => {
  if (!items) return 0;
  return items.reduce((sum, item) => {
    const ventes = parseInt(item.quantitevte || 0) + parseInt(item.quantiteneg || 0);
    return sum + ventes;
  }, 0);
};

const getGroupTotalReceptions = (items) => {
  if (!items) return 0;
  return items.reduce((sum, item) => sum + parseInt(item.quantitebrf || 0), 0);
};

const getGroupTaux = (items) => {
  const ventes = getGroupTotalVentes(items);
  const receptions = getGroupTotalReceptions(items);
  if (receptions === 0) return 0;
  return ((ventes / receptions) * 100).toFixed(2);
};

const getGroupTauxColor = (items) => {
  const taux = parseFloat(getGroupTaux(items));
  if (taux > 100) return 'success';
  if (taux > 50) return 'warning';
  return 'error';
};

// Fonctions pour les items
const getItemTaux = (item) => {
  const ventes = parseInt(item.quantitevte || 0) + parseInt(item.quantiteneg || 0);
  const receptions = parseInt(item.quantitebrf || 0);
  if (receptions === 0) return 0;
  return ((ventes / receptions) * 100).toFixed(2);
};

const getItemTauxColor = (item) => {
  if (!item) return 'grey';
  const taux = parseFloat(getItemTaux(item));
  if (taux > 100) return 'success';
  if (taux > 50) return 'warning';
  return 'error';
};

// Fonction pour obtenir les labels des ventes
const getSalesLabels = () => {
  const labels = [];
  if (props.quantityLabels?.frontOfficeSalesQuantity?.libelle) {
    labels.push(props.quantityLabels.frontOfficeSalesQuantity.libelle);
  }
  if (props.quantityLabels?.customerDeliveryQuantity?.libelle) {
    labels.push(props.quantityLabels.customerDeliveryQuantity.libelle);
  }
  if (props.quantityLabels?.customerInvoiceQuantity?.libelle) {
    labels.push(props.quantityLabels.customerInvoiceQuantity.libelle);
  }
  return labels.join(' + ') || 'Ventes totales';
};

// Fonction pour obtenir la couleur du taux global
const getTauxColor = () => {
  const taux = stats.value.tauxRevente / 100;
  if (taux > 1) return 'success';
  if (taux > 0.5) return 'warning';
  return 'error';
};

// Fonction pour obtenir l'interprétation du taux
const getRateInterpretation = () => {
  const taux = stats.value.tauxRevente / 100;
  if (taux > 1) return 'Excellent taux de revente';
  if (taux > 0.7) return 'Bon taux de revente';
  if (taux > 0.5) return 'Taux de revente moyen';
  if (taux > 0.3) return 'Taux de revente faible';
  return 'Taux de revente très faible';
};

// Afficher les détails
const showDetails = (item) => {
  selectedItem.value = item;
  dialogVisible.value = true;
};
// Fonction Pour récupérer les saisons
let saisons=ref([])
const fetchSaisons = async () => {
  try {
    error.value = null;

    const response = await axios.get('https://my.edisac.com/api/getsaisons', {
      params: {
        p_code_article: props.p_code_article.substring(0,12),
        p_codeabarre: props.p_codeabarre?props.p_codeabarre:null
      }
      
    });
    // 
    // console.log(props);

    const apiData = response.data.data;
    // console.log(apiData);
    
    if (apiData && apiData.length > 0) {
      saisons.value=apiData
      // console.log(saisons.value);
      
    }

    loading.value = false;
  } catch (err) {
    error.value = err.message || 'Erreur lors du chargement des données';
  }
} 
// Fonction pour récupérer les données
const fetchData = async () => {
  // console.log(saison);
  
  try {
    loading.value = true;
    error.value = null;

    const response = await axios.get('https://my.edisac.com/api/gettauxrevente', {
      params: {
        // p_utilisateur: `EXPORT${new Date().getFullYear().toString().slice(-2)}`,
        p_saison: saison.value,
        p_code_article: props.p_code_article.substring(0,12),
        p_codeabarre: props.p_codeabarre?props.p_codeabarre:null
      }
      
    });
    // 
    // console.log(response.data.data);

    const apiData = response.data.data;

    if (apiData && apiData.data && apiData.data.length > 0) {
      let totalVentes = 0;
      let totalReceptions = 0;
      let supplyByEtab = {};

      // Si total > 1, regroupement par code_article
      if (apiData.total > 1) {
        isRegrouped.value = true;
        
        // Grouper les données par code_article
        const groupedMap = {};
        apiData.data.forEach(item => {
          const codeArticle = item.code_article;
          if (!groupedMap[codeArticle]) {
            groupedMap[codeArticle] = {
              code_article: codeArticle,
              items: [],
              // Copier les propriétés du premier élément
              codeabarre: item.codeabarre,
              couleur: item.couleur,
              taille: item.taille,
              marque: item.marque,
              saison: item.saison,
              quantitevte: 0,
              quantiteneg: 0,
              quantitebrf: 0
            };
          }
          
          // Ajouter l'item au groupe
          groupedMap[codeArticle].items.push(item);
          
          // Accumuler les quantités
          groupedMap[codeArticle].quantitevte += parseInt(item.quantitevte || 0);
          groupedMap[codeArticle].quantiteneg += parseInt(item.quantiteneg || 0);
          groupedMap[codeArticle].quantitebrf += parseInt(item.quantitebrf || 0);

          // Regroupement par établissement
          const etab = item.pole || 'Autre';
          if (!supplyByEtab[etab]) {
            supplyByEtab[etab] = 0;
          }
          supplyByEtab[etab] += parseInt(item.quantitebrf || 0);
        });

        // Convertir en tableau
        data.value = Object.values(groupedMap);

        // Calcul des totaux
        data.value.forEach(item => {
          totalVentes += parseInt(item.quantitevte || 0) + parseInt(item.quantiteneg || 0);
          totalReceptions += parseInt(item.quantitebrf || 0);
        });
      } else {
        // Pas de regroupement nécessaire
        isRegrouped.value = false;
        const item = apiData.data[0];
        totalVentes = parseInt(item.quantitevte || 0) + parseInt(item.quantiteneg || 0);
        totalReceptions = parseInt(item.quantitebrf || 0);
        
        // Approvisionnement par établissement
        const etab = item.pole || 'Autre';
        supplyByEtab[etab] = parseInt(item.quantitebrf || 0);
        
        data.value = apiData.data.map(item => ({
          ...item,
          taux: getItemTaux(item)
        }));
      }

      etabSupply.value = supplyByEtab;

      // Calcul du taux de revente
      const tauxRevente = totalReceptions > 0 
        ? (totalVentes / totalReceptions) * 100 
        : 0;

      stats.value = {
        totalVentes,
        totalReceptions,
        tauxRevente
      };
    }

    loading.value = false;
  } catch (err) {
    error.value = err.message || 'Erreur lors du chargement des données';
    loading.value = false;
  }
};

// Chargement initial
onMounted(() => {
  fetchData();
  fetchSaisons()
});

// Rechargement quand les props changent
watch(
  () => [props.p_saison, props.p_code_article, props.p_codeabarre],
  () => {
    fetchData();
  },
  { deep: true }
);
</script>

<style scoped>
.taux-revente-container {
  padding: 16px;
}

/* Animation pour les cartes */
.v-card {
  transition: transform 0.2s, box-shadow 0.2s;
}

.v-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
}

/* Style du tableau */
.v-table {
  border-radius: 8px;
}

.v-table thead th {
  background: #f5f5f5 !important;
  font-weight: 600 !important;
}

.v-table tbody tr:hover {
  background-color: #f8f9fa !important;
}

/* En-tête de groupe */
.group-header {
  background-color: #f5f5f5 !important;
  font-weight: 500;
  padding: 12px 16px;
}

.group-header:hover {
  background-color: #e8e8e8 !important;
}

.cursor-pointer {
  cursor: pointer;
}

/* Chips dans le tableau */
.v-chip {
  font-weight: 500;
}

/* Responsive */
@media (max-width: 600px) {
  .v-card .text-h6 {
    font-size: 18px !important;
  }
  
  .v-table {
    font-size: 12px;
  }
  
  .v-table td,
  .v-table th {
    padding: 8px 4px !important;
  }
}
</style>